import type { DocumentRotation } from '@v2/components/imageHandling/components/DrawingCanvas/types';

/** Snaps an arbitrary document rotation angle to the nearest quarter turn. */
export const normalizeRotation = (rawAngle: number): DocumentRotation => {
  const a = ((rawAngle % 360) + 360) % 360;
  if (a >= 45 && a < 135) return 90;
  if (a >= 135 && a < 225) return 180;
  if (a >= 225 && a < 315) return 270;
  return 0;
};
